<style lang="stylus">
  .take-card {
    display: flex;
    align-items: stretch;
    margin-top: 0.3rem;
    border: 1px solid #ccc;
    min-height: 2.1rem;
    .left {
      flex: 1;
      text-align: center;
      color: #f13b3a;
      border-right: 2px #ccc dashed;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .amount {
        font-size: 0.6rem;
        font-weight: bold;
      }
      .num {
        margin-top: 0.2rem;
        font-size: 0.35rem;
      }
    }
    .right {
      flex: 2;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      padding: 0.15rem 0.2rem;
    }
  }
</style>
<template>
  <div class="take-card">
    <div class="left">
      <div>¥<span class="amount">{{reduceCost}}</span></div>
      <div class="num">×{{card.num || 1}}</div>
    </div>
    <div class="right">
      <div>{{card.title}}</div>
      <div>满{{card.least_cost}}元可用</div>
      <div>{{effectDate}}</div>
    </div>
  </div>
</template>
<script>
  import {formatTimestamp} from 'src/components/api/utils';
  /**
   * 领券活动的单个卡券
   */
  export default {
    // 使用其它组件
    components: {},
    props: {
      card: {
        type: Object,
        default: {}
      }
    },
    // 属性
    data () {
      return {}
    },
    // 计算属性
    computed: {
      // 有效期
      effectDate: function () {
        let {type, begin_timestamp, end_timestamp, fixed_begin_term: beginTerm, fixed_term: fixedTerm} = this.card;
        if (type === 'DATE_TYPE_FIX_TIME_RANGE') { // 固定日期
          let beginDate = formatTimestamp(begin_timestamp);
          let endDate = formatTimestamp(end_timestamp);
          return beginDate.substring(0, 10) + ' 至 ' + endDate.substring(0, 10);
        }
        if (type === 'DATE_TYPE_FIX_TERM') {
          beginTerm = beginTerm > 0 ? beginTerm : '当';
          return `领券后${beginTerm}天生效，${fixedTerm}天有效`
        }
        return '';
      },
      reduceCost: function () {
        let amount = (this.card.reduce_cost || 0) - 0;
        return amount.toFixed(2)
      }
    },
    watch: {},
    // 生命周期函数
    created () {},
    mounted () {},
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/common/TakeCardItem.vue